import { Box, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  CoverageOptions,
  EmployeeOptions,
  OtherOptions,
  ScheduleOptions,
} from 'modules/shift_management/store/internal/models/ViewOptions'

type Options =
  | keyof EmployeeOptions
  | keyof ScheduleOptions
  | keyof CoverageOptions
  | keyof OtherOptions

interface Props {
  option: Options
  value: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

const Toggler = ({ option, value, disabled = false, onChange }: Props) => {
  const translations: Record<Options, string> = {
    showBreaks: i18n.t('shift_management.view_options.breaks'),
    showCompactView: i18n.t('shift_management.view_options.compactView'),
    showContractHours: i18n.t('shift_management.view_options.contractHours'),
    showName: i18n.t('shift_management.view_options.name'),
    showNotes: i18n.t('shift_management.view_options.notes'),
    showOvertime: i18n.t('shift_management.view_options.overtime'),
    showPlannedHours: i18n.t('shift_management.view_options.plannedHours'),
    showJobPosition: i18n.t('shift_management.view_options.jobPosition'),
    showWorkArea: i18n.t('shift_management.view_options.workArea'),
    showWorkplace: i18n.t('shift_management.view_options.workplace'),
    showBackupShifts: i18n.t('shift_management.view_options.backup_shifts'),
    showPlanningBalance: i18n.t('shift_management.view_options.planning_balance'),
    showBankOfHours: i18n.t('shift_management.view_options.bank_of_hours'),
    showRole: i18n.t('shift_management.view_options.role'),
    showAvatar: i18n.t('shift_management.view_options.avatar'),
  }

  const optionName: string = translations[option] || option

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
      <Text.Normal color="grey800" size="200">
        {optionName}
      </Text.Normal>

      <TogglerCheckbox labelBefore value={value} disabled={disabled} onChange={onChange} />
    </Box>
  )
}

export default observer(Toggler)
